import { useErrorOnNotOkFetchye } from '@americanexpress/fetchye-amex';
import { v4 as uuidv4 } from 'uuid';
import { ignoreHeadersByKey } from 'fetchye';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useFeatureFlagWithProperties } from '../thunks/useFeatureFlagWithProperties';
import { GET_INSPIRED_FF } from '../constants/oneXpConstants';
import { getFaasApiUrlSelector } from '../selectors/getDomainSelectors';

export const useGetInspirationalArticlesHook = (isInViewport) => {
  const searchParams = new URLSearchParams(global.BROWSER ? window.location.search : '');
  const locale = useSelector(getActiveLocaleSelector);
  const oneDataBaseUrl = useSelector(getFaasApiUrlSelector);
  const shouldDisplayGetInspired = useFeatureFlagWithProperties(GET_INSPIRED_FF);
  const { data, error, isLoading } = useErrorOnNotOkFetchye(`${oneDataBaseUrl}/ReadGetInspiredArticles.v1`, {
    defer: !shouldDisplayGetInspired || !isInViewport,
    mapOptionsToKey: ignoreHeadersByKey(['one-data-correlation-id']),
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      locale,
      clientId: 'PREBOOKING_WEB',
    }),
    headers: {
      'Content-Type': 'application/json',
      'one-data-correlation-id': uuidv4(),
    },
  });

  const articlesToShow = Number.parseInt(searchParams.get('showGetInspiredExploreMore'), 10) === 1 ? 3 : 4;

  const articles = data?.body?.getInspired;
  if (articles) {
    Object.keys(articles)
      .forEach((key) => { articles[key] = articles[key].slice(0, articlesToShow); });
  }

  return {
    data: articles,
    isLoading,
    error,
  };
};
